import type { MemberChatPreferences } from 'src/types/user';
import { CHAT_PANEL_WIDTH, CHAT_THEME } from 'admin/constants/story-editor-chat';

export const DEFAULT_MEMBER_CHAT_PREFERENCES: MemberChatPreferences = {
	open: true,
	theme: CHAT_THEME.PAPER,
	width: CHAT_PANEL_WIDTH.DEFAULT,
};
